/* eslint-disable no-restricted-imports */
import { useDispatch as useOriginDispatch } from 'react-redux';
import { AnyAction } from 'typescript-fsa';
import { Dispatch } from 'redux';

export const useDispatch = useOriginDispatch.withTypes<Dispatch<AnyAction>>();
